// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {Link, withRouter} from "react-router-dom";
// Material
import {CircularProgress, Divider, IconButton, Switch, Tooltip} from "@material-ui/core";
// Vendor
import {showNotify} from "vendor/application/disptach";
// Infrastructure
import {IntegrationsAPI} from "api/application/Integrations";
import {BusinessAPI} from "views/Bots/ChatBot/application/Tabs/BusinessHours/infrastructure";
// Application
import {ElementsHandleAPI} from "vendor/application/handleMethods";
import {getCentrideskBody, getStatusArray} from "vendor/application";
// Translations
import {withTranslation} from "react-i18next";
// Components
import {Button} from "@components/Input";
import {ElementsCustom} from "@components/Elements";
import DialogAction from "components/Dialog/DialogAction";
import {MailboxCreation, mailboxState, BUSY_STATES} from "./mailbox_creation";
import MailboxCreationDialog from "./mailbox_creation_dialog";
import {mailboxInputError} from "./mailbox_input";
import TicketReuseSettings, {
    isValidTicketReuseWindow,
    normalizeTicketReuseWindow,
    toggleTicketReuse
} from "./ticket_reuse_settings";
// SVG
import {channelsSvg, tableSuccessSvg, warningSvg, pendingSvg, inProgressSvg} from "assets";
import {arrowRightSvg, deleteSvg} from "@assets";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centridesk: false,
            hours: "",
            integration: true,
            tagValid: true,
            open: false,
            emails: [],
            checkingStatus: false,
            addingEmail: false,
            mailboxCreation: null,
            mailboxCreationOpen: false,
            ticketReuseEnabled: false,
            savedTicketReuseWindowHours: 0,
            savedTicketReuseCloseMessage: "",
            newEmailParts: {
                customerMail: "",
                customerDomainName: ""
            },
            deskDomainName: "",
            settings: {
                tags: "",
                tags_hours_control: "",
                tags_individual: "",
                tags_campaign: ""
            }
        };
    }

    componentDidMount() {
        this.getHours();
        this.getIntegration();
    }

    componentWillUnmount() {
        this.unmounted = true;
        clearTimeout(this.emailPoll);
        this.mailboxCreation?.cancel();
    }

    // get integrations from actual project id
    getIntegration = async () => {
        const {access, actualProject} = this.props.data;
        try {
            let obj = new IntegrationsAPI(actualProject.id, access, this.props);
            let integration = await obj.get_integration_by_id();
            let default_integration = getCentrideskBody();

            if (!integration.info.centripush) {
                integration.info.centripush = {...default_integration.info.centripush};
            }
            if (integration.info.use_custom_fields === undefined) {
                integration.info.use_custom_fields = false;
            }
            if (!integration.info.hours_control) {
                integration.info.hours_control = {
                    "subject": "",
                    "tags": [],
                    "status": "new",
                    "active": false
                };
            }
            if (integration.info.assign_ticket_with_ai === undefined) {
                integration.info.assign_ticket_with_ai = false;
            }
            const ticketReuseWindow = Number(integration.info.ticket_reuse_window_hours || 0);
            integration.info.ticket_reuse_window_hours = Number.isInteger(ticketReuseWindow) && ticketReuseWindow > 0
                ? ticketReuseWindow
                : 0;
            if (integration.info.ticket_reuse_close_message === undefined) {
                integration.info.ticket_reuse_close_message = this.props.t(
                    "integrations:channels.centridesk.ticket_reuse.close_message.default",
                    {hours: "{{hours}}"}
                );
            }

            this.setState({
                centridesk: integration,
                ticketReuseEnabled: integration.info.ticket_reuse_window_hours > 0,
                savedTicketReuseWindowHours: integration.info.ticket_reuse_window_hours,
                savedTicketReuseCloseMessage: integration.info.ticket_reuse_close_message
            });
            this.fetchEmails(integration.id);
            try {
                const config = await obj.get_mailbox_configuration(integration.id);
                if (!this.unmounted) this.setState({deskDomainName: config.desk_domain_name});
            } catch (error) {
                if (!this.unmounted) this.setState({mailboxConfigError: true});
            }
        } catch (err) {
            var data = {message: err, severity: "error"};
            this.props.dispatch(showNotify(data));
            this.return();
        }
    };

    fetchEmails = async (channelId) => {
        const {access, actualProject} = this.props.data;
        try {
            let obj = new IntegrationsAPI(actualProject.id, access, this.props);
            let emails = await obj.get_channel_emails(channelId);
            if (this.unmounted) return;
            this.setState({emails: emails || []});
            clearTimeout(this.emailPoll);
            this.emailPoll = setTimeout(() => this.fetchEmails(channelId), 10000);
        } catch (err) {
            if (!this.unmounted) this.emailPoll = setTimeout(() => this.fetchEmails(channelId), 10000);
            console.error("Error fetching emails:", err);
        }
    };

    sanitizeDomain = (value) => {
        return value.toLowerCase();
    };

    sanitizeMail = (value) => {
        return value.toLowerCase();
    };

    addEmail = async () => {
        const {newEmailParts, deskDomainName} = this.state;
        const {customerMail, customerDomainName} = newEmailParts;

        if (!customerMail || !customerDomainName || this.state.addingEmail || !deskDomainName ||
            mailboxInputError(newEmailParts, deskDomainName)) return;

        const senderEmail = `${customerMail}@${customerDomainName}.${deskDomainName}`;

        this.startMailboxCreation(senderEmail, true);
    };

    startMailboxCreation = (senderEmail, submit = false, operation = null, emailId = null) => {
        if (this.state.addingEmail) return;
        this.setState({addingEmail: true, mailboxCreationOpen: true, mailboxCreation: {phase: "checking", senderEmail}});
        const {access, actualProject} = this.props.data;
        this.mailboxCreation?.cancel();
        this.mailboxCreation = new MailboxCreation({
            api: new IntegrationsAPI(actualProject.id, access, this.props),
            channelId: this.state.centridesk.id,
            senderEmail, operation, emailId, action: emailId ? "retry" : "create",
            onEmails: emails => this.setState({emails}),
            onUpdate: creation => {
                this.setState({
                    mailboxCreation: creation,
                    addingEmail: false,
                    ...(creation.phase === "success" && {
                        newEmailParts: {customerMail: "", customerDomainName: ""}
                    })
                });
                if (creation.error) this.props.dispatch(showNotify({message: creation.error, severity: "error"}));
            }
        });
        this.mailboxCreation.start(submit);
    };

    checkAllEmailsStatus = async () => {
        const {access, actualProject} = this.props.data;
        const {centridesk, emails} = this.state;

        this.setState({checkingStatus: true});
        for (const email of emails) {
            try {
                let obj = new IntegrationsAPI(actualProject.id, access, this.props);
                const updated = await obj.check_email_status(centridesk.id, email.id);
                this.setState(prev => ({
                    emails: prev.emails.map(e => e.id === email.id ? {...e, stack_status: updated.stack_status} : e)
                }));
            } catch (err) {
                this.props.dispatch(showNotify({message: err, severity: "error"}));
            }
        }
        this.setState({checkingStatus: false});
    };

    setDefaultEmail = async (emailId) => {
        const {access, actualProject} = this.props.data;
        const {centridesk} = this.state;
        try {
            let obj = new IntegrationsAPI(actualProject.id, access, this.props);
            await obj.patch_channel_email(centridesk.id, emailId, {is_default: true});
            this.setState(prev => ({
                emails: prev.emails.map(e => ({...e, is_default: e.id === emailId}))
            }));
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    removeEmail = async (emailId) => {
        const {access, actualProject} = this.props.data;
        const {centridesk} = this.state;

        try {
            let obj = new IntegrationsAPI(actualProject.id, access, this.props);
            const operation = await obj.delete_channel_email(centridesk.id, emailId);
            this.startMailboxCreation(operation.sender_email, false, operation);
            this.fetchEmails(centridesk.id);
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    getHours = async () => {
        const {access, actualProject} = this.props.data;
        try {
            const obj = new BusinessAPI(actualProject.id, access, this.props);
            const hours = await obj.get_hours();

            this.setState({hours: hours});
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    // update element state
    updateElement = (e, type, i) => {
        const {centridesk} = this.state;
        const obj = new ElementsHandleAPI(centridesk.info, e.target.value, type, i);
        obj.updateObj();
        this.setState({centridesk: centridesk});
    };

    return = () => {
        const {history} = this.props;
        const {actualProject} = this.props.data;
        history.push(`/${actualProject.id}/integrations`);
    };

    putIntegration = async (e) => {
        e.preventDefault();
        const {access, actualProject} = this.props.data;
        const {centridesk} = this.state;
        if (!isValidTicketReuseWindow(this.state.ticketReuseEnabled, centridesk.info.ticket_reuse_window_hours)) {
            return;
        }
        const ticketReuseWindowHours = normalizeTicketReuseWindow(
            this.state.ticketReuseEnabled,
            centridesk.info.ticket_reuse_window_hours
        );
        const ticketReuseChanged = ticketReuseWindowHours !== this.state.savedTicketReuseWindowHours
            || centridesk.info.ticket_reuse_close_message !== this.state.savedTicketReuseCloseMessage;
        centridesk.info.ticket_reuse_window_hours = ticketReuseWindowHours;
        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props, centridesk);
            await obj.put_integration();
            this.setState({
                savedTicketReuseWindowHours: ticketReuseWindowHours,
                savedTicketReuseCloseMessage: centridesk.info.ticket_reuse_close_message
            });
            this.props.dispatch(showNotify({
                message: ticketReuseChanged ? "conversation_continuity" : "integrations",
                type: "edit",
                severity: "success"
            }));
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    toggleTicketReuse = () => {
        const {centridesk, ticketReuseEnabled} = this.state;
        centridesk.info.ticket_reuse_window_hours = toggleTicketReuse(ticketReuseEnabled);
        this.setState({centridesk, ticketReuseEnabled: !ticketReuseEnabled});
    };

    updateTicketReuseWindow = (e) => {
        const {centridesk} = this.state;
        centridesk.info.ticket_reuse_window_hours = e.target.value;
        this.setState({centridesk});
    };

    updateTicketReuseCloseMessage = (e) => {
        const {centridesk} = this.state;
        centridesk.info.ticket_reuse_close_message = e.target.value;
        this.setState({centridesk});
    };

    handleDelete = async () => {
        const {access, actualProject} = this.props.data;
        const {centridesk} = this.state;
        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props);
            await obj.delete_integration(centridesk.id);

            this.props.dispatch(showNotify({message: "integrations", type: "delete", severity: "success"}));

            this.return();
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    handleTags = (e, type, elementType, chipToDelete, i) => {
        const {centridesk, settings} = this.state;
        var element_to_update;

        switch (elementType) {
            case "tags":
                element_to_update = centridesk.info.tags;
                break;
            case "tags_hours_control":
                element_to_update = centridesk.info.hours_control.tags;
                break;
            case "tags_individual":
                element_to_update = centridesk.info.centripush.individual.tags;
                break;
            case "tags_campaign":
                element_to_update = centridesk.info.centripush.campaign.tags;
                break;
        }

        var tag = e.target.value;
        switch (type) {
            case "add":
                if (tag.match(/^[a-zA-Z0-9_\/]*$/)) {
                    settings[elementType] = tag;
                    this.setState({settings: settings});
                }
                break;
            case "delete":
                element_to_update.forEach(el => {
                    if (el === chipToDelete) {
                        element_to_update.splice(i, 1);
                    }
                });
                this.setState({centridesk: centridesk});
                break;
            case "enter":
                element_to_update.push(tag);
                settings[elementType] = "";
                this.setState({centridesk: centridesk, settings: settings});
                break;
        }
    };

    onSelectStatus = (e, type) => {
        const {centridesk} = this.state;
        switch (type) {
            case "status_hours_control":
                centridesk.info.hours_control.status = e;
                break;
            case "status_campaign":
                centridesk.info.centripush.campaign.status = e;
                break;
            case "status_individual":
                centridesk.info.centripush.individual.status = e;
                break;
        }
        this.setState({centridesk: centridesk});
    };

    getEmailStatusIcon = (status) => {
        switch (status) {
            case "CREATE_COMPLETE":
            case "UPDATE_COMPLETE":
            case "active":
                return tableSuccessSvg();
            case "CREATE_IN_PROGRESS":
            case "UPDATE_IN_PROGRESS":
            case "in_progress":
                return inProgressSvg();
            case "REVIEW_IN_PROGRESS":
            case "pending":
            case "waiting":
            case "checking":
            case "deleting":
                return pendingSvg();
            default:
                return warningSvg();
        }
    };

    render() {
        const {centridesk, hours, settings, open, checkingStatus, ticketReuseEnabled} = this.state;
        const {t, match} = this.props;
        const {limits, isSending, plan, actualLayout} = this.props.data;
        const emailInputError = mailboxInputError(this.state.newEmailParts, this.state.deskDomainName);
        return (
            <React.Fragment>
                <MailboxCreationDialog
                    creation={this.state.mailboxCreation}
                    open={this.state.mailboxCreationOpen}
                    onClose={() => this.setState({mailboxCreationOpen: false})}
                    onCheck={() => { this.fetchEmails(this.state.centridesk.id); this.setState({mailboxCreationOpen: false}); }}
                    t={t}
                />
                {/* INFO */}
                <div className={"cen_integrations"}>
                    <div className={"header"}>
                        <div className={"header_content"}>
                            <div onClick={() => this.return()} className={"header_action"}>
                                {arrowRightSvg()}
                            </div>
                            <div className={"header_image"}>
                                {channelsSvg("centridesk")}
                            </div>
                            <div className={"header_title"}>
                                <span className={"title"}>{t("integrations:channels.centridesk.title")}</span>
                                <span className={"description"}>{t("integrations:categories.business")}</span>
                            </div>
                        </div>
                        <div className={"header_actions"}>
                            {
                                isSending ? (
                                    <Button type={"primary"} disabled text={<CircularProgress size={21}/>}/>
                                ) : (
                                    <Button type={"primary"}
                                            disabled={!centridesk || !isValidTicketReuseWindow(ticketReuseEnabled, centridesk.info.ticket_reuse_window_hours)}
                                            text={t("integrations:save.action_button")}
                                            onClick={(e) => this.putIntegration(e)}/>
                                )
                            }
                        </div>
                    </div>
                    {
                        centridesk
                            ? <div className={"integration"}>
                                {/* ZENDESK EMAIL */}
                                <ElementsCustom
                                    t={t}
                                    type={"centridesk"}
                                    input_type={"input"}
                                    element_type={"subject"}
                                    element={centridesk.info.subject}
                                    updateElement={this.updateElement}
                                />
                                <Divider/>
                                {/* TAGS */}
                                <ElementsCustom
                                    t={t}
                                    type={"centridesk"}
                                    input_type={"input_with_tags"}
                                    element_type={"tags"}
                                    element={settings.tags}
                                    elements={centridesk.info.tags}
                                    updateElement={this.handleTags}
                                />
                                <Divider/>
                                {/* CENTRIDESK CUSTOM FIELDS */}
                                <ElementsCustom
                                    t={t}
                                    type={"centridesk"}
                                    input_type={"switch"}
                                    element_type={"use_custom_fields"}
                                    element={centridesk.info.use_custom_fields}
                                    updateElement={this.updateElement}
                                />
                                <Divider/>
                                {/* ASSIGN TICKET WITH AI */}
                                <ElementsCustom
                                    t={t}
                                    type={"centridesk"}
                                    input_type={"switch"}
                                    element_type={"assign_ticket_with_ai"}
                                    element={centridesk.info.assign_ticket_with_ai}
                                    updateElement={this.updateElement}
                                />
                                <Divider/>
                                <TicketReuseSettings
                                    t={t}
                                    enabled={ticketReuseEnabled}
                                    value={centridesk.info.ticket_reuse_window_hours}
                                    closeMessage={centridesk.info.ticket_reuse_close_message}
                                    onToggle={this.toggleTicketReuse}
                                    onChange={this.updateTicketReuseWindow}
                                    onCloseMessageChange={this.updateTicketReuseCloseMessage}
                                />
                            </div>
                            : <div className={"content"}>
                                <div className="loading">
                                    <CircularProgress color="primary" size={50}/>
                                </div>
                            </div>
                    }
                </div>
                {
                    centridesk &&
                        <React.Fragment>
                            {/* EMAIL ADDRESSES SECTION */}
                            <div className={"cen_integrations"}>
                                <div className={"header"}>
                                    <div className={"header_content"}>
                                        <div className={"header_title"}>
                                            <span className={"title"}>{t("integrations:channels.centridesk.emails.title")}</span>
                                            <span className={"description"}>{t("integrations:channels.centridesk.emails.description")}</span>
                                        </div>
                                    </div>
                                    {this.state.emails.length > 0 && (
                                        <div className={"header_actions"}>
                                            <Tooltip title={t("integrations:channels.centridesk.emails.refresh_status")} placement="top">
                                                <span>
                                                    <IconButton
                                                        onClick={() => this.checkAllEmailsStatus()}
                                                        disabled={checkingStatus}
                                                        style={{backgroundColor: "transparent", transition: "transform 0.6s", transform: checkingStatus ? "rotate(360deg)" : "none"}}
                                                        disableRipple disableFocusRipple
                                                        aria-label={t("integrations:channels.centridesk.emails.refresh_status")}
                                                        size="small"
                                                    >
                                                        {checkingStatus ? <CircularProgress size={20}/> : (
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11 20.95C8.98333 20.7 7.31233 19.821 5.987 18.313C4.66167 16.805 3.99933 15.034 4 13C4 11.9 4.21667 10.8457 4.65 9.837C5.08333 8.82833 5.7 7.94933 6.5 7.2L7.925 8.625C7.29167 9.19167 6.81233 9.85 6.487 10.6C6.16167 11.35 5.99933 12.15 6 13C6 14.4667 6.46667 15.7627 7.4 16.888C8.33333 18.0133 9.53333 18.7007 11 18.95V20.95ZM13 20.95V18.95C14.45 18.6833 15.646 17.9917 16.588 16.875C17.53 15.7583 18.0007 14.4667 18 13C18 11.3333 17.4167 9.91667 16.25 8.75C15.0833 7.58333 13.6667 7 12 7H11.925L13.025 8.1L11.625 9.5L8.125 6L11.625 2.5L13.025 3.9L11.925 5H12C14.2333 5 16.125 5.775 17.675 7.325C19.225 8.875 20 10.7667 20 13C20 15.0167 19.3373 16.7793 18.012 18.288C16.6867 19.7967 15.016 20.684 13 20.95Z" fill="#565671"/>
                                                            </svg>
                                                        )}
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                                <div className={"integration"}>
                                    {this.state.mailboxConfigError && <p role="alert">{t("integrations:channels.centridesk.emails.errors.MAILBOX_CONFIGURATION")}</p>}
                                    {/* Add new email form */}
                                    <div style={{display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap"}}>
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <ElementsCustom
                                                t={t}
                                                type={"centridesk"}
                                                input_type={"input"}
                                                element_type={"customer_mail"}
                                                element={this.state.newEmailParts.customerMail}
                                                placeholder={"support"}
                                                updateElement={(e) => this.setState({newEmailParts: {...this.state.newEmailParts, customerMail: this.sanitizeMail(e.target.value)}})}
                                            />
                                        </div>
                                        <span style={{whiteSpace: "nowrap"}}>@</span>
                                        <div style={{flex: 1, minWidth: 0}}>
                                            <ElementsCustom
                                                t={t}
                                                type={"centridesk"}
                                                input_type={"input"}
                                                element_type={"customer_domain"}
                                                element={this.state.newEmailParts.customerDomainName}
                                                placeholder={"mycompany"}
                                                updateElement={(e) => this.setState({newEmailParts: {...this.state.newEmailParts, customerDomainName: this.sanitizeDomain(e.target.value)}})}
                                            />
                                        </div>
                                        <span style={{whiteSpace: "nowrap"}}>.{this.state.deskDomainName}</span>
                                        <Button
                                            type={"primary"}
                                            text={t("integrations:channels.centridesk.emails.add")}
                                            disabled={!this.state.newEmailParts.customerMail || !this.state.newEmailParts.customerDomainName || !!emailInputError || !this.state.deskDomainName || this.state.addingEmail}
                                            onClick={() => this.addEmail()}
                                        />
                                    </div>
                                    {emailInputError && <p role="alert">{t(`integrations:channels.centridesk.emails.${emailInputError}`)}</p>}
                                    {this.state.mailboxCreation && !this.state.mailboxCreationOpen && (
                                        <Button type="secondary"
                                                text={t(`integrations:channels.centridesk.emails.creation.${this.state.mailboxCreation.phase}.title`)}
                                                onClick={() => this.setState({mailboxCreationOpen: true})}/>
                                    )}
                                    {/* Existing emails list */}
                                    {this.state.emails.length > 0 && (
                                        <div style={{marginTop: 20, overflowX: "auto"}}>
                                            {/* Table header */}
                                            <div style={{display: "grid", minWidth: 660, gridTemplateColumns: "minmax(200px, 1fr) 100px 130px minmax(140px, auto)", gap: 8, alignItems: "center", padding: "8px 24px 8px 12px", backgroundColor: "#f5f5f5", borderRadius: "4px 4px 0 0", border: "1px solid #e0e0e0"}}>
                                                <span style={{fontSize: 12, fontWeight: 600, color: "#565671"}}>{t("integrations:channels.centridesk.emails.columns.email")}</span>
                                                <span style={{fontSize: 12, fontWeight: 600, color: "#565671", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 4}}>
                                                    {t("integrations:channels.centridesk.emails.columns.status")}
                                                    <Tooltip title={t("integrations:channels.centridesk.emails.columns.status_hint")} placement="top">
                                                        <span style={{display: "inline-flex", alignItems: "center", justifyContent: "center", width: 14, height: 14, borderRadius: "50%", backgroundColor: "#565671", color: "#ffffff", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0}}>?</span>
                                                    </Tooltip>
                                                </span>
                                                <span style={{fontSize: 12, fontWeight: 600, color: "#565671", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: 4}}>
                                                    {t("integrations:channels.centridesk.emails.columns.is_default")}
                                                    <Tooltip title={t("integrations:channels.centridesk.emails.columns.is_default_hint")} placement="top">
                                                        <span style={{display: "inline-flex", alignItems: "center", justifyContent: "center", width: 14, height: 14, borderRadius: "50%", backgroundColor: "#565671", color: "#ffffff", fontSize: 10, fontWeight: 700, cursor: "help", flexShrink: 0}}>?</span>
                                                    </Tooltip>
                                                </span>
                                                <span style={{fontSize: 12, fontWeight: 600, color: "#565671", textAlign: "center"}}>{t("integrations:channels.centridesk.emails.columns.actions")}</span>
                                            </div>
                                            {/* Table rows */}
                                            {this.state.emails.map((email) => {
                                                const emailStatus = mailboxState(email);
                                                const busy = email.operation && BUSY_STATES.includes(email.operation.state);
                                                const statusText = t(`integrations:channels.centridesk.emails.states.${emailStatus}`);
                                                const errorText = email.operation?.error_code
                                                    ? t(`integrations:channels.centridesk.emails.errors.${email.operation.error_code}`, t("integrations:channels.centridesk.emails.errors.default"))
                                                    : "";
                                                const alertStatus = emailStatus === "failed" || emailStatus === "requires_review";
                                                return (
                                                    <div key={email.id} style={{display: "grid", minWidth: 660, gridTemplateColumns: "minmax(200px, 1fr) 100px 130px minmax(140px, auto)", gap: 8, alignItems: "center", padding: "4px 24px 4px 12px", backgroundColor: "#ffffff", borderLeft: "1px solid #e0e0e0", borderRight: "1px solid #e0e0e0", borderBottom: "1px solid #e0e0e0"}}>
                                                        <span style={{fontSize: 13, color: "#565671", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                                                            {email.sender_email}
                                                        </span>
                                                        <div style={{display: "flex", justifyContent: "center"}}>
                                                            <Tooltip title={<span>{statusText}{errorText && <><br/>{errorText}</>}</span>} placement="top" enterTouchDelay={0}>
                                                                <span tabIndex={0} role="img" aria-label={errorText ? `${statusText}. ${errorText}` : statusText}
                                                                      style={{display: "flex", alignItems: "center", cursor: "default"}}>
                                                                    {this.getEmailStatusIcon(emailStatus)}
                                                                </span>
                                                            </Tooltip>
                                                            {!alertStatus && <span role="status">{statusText}</span>}
                                                        </div>
                                                        <div style={{display: "flex", justifyContent: "center"}}>
                                                            <Tooltip title={email.is_default ? "" : t("integrations:channels.centridesk.emails.is_default.activate")} placement="top">
                                                                <Switch
                                                                    disabled={!!busy}
                                                                    checked={!!email.is_default}
                                                                    onChange={() => !email.is_default && this.setDefaultEmail(email.id)}
                                                                    color="primary"
                                                                    size="small"
                                                                    inputProps={{"aria-label": t("integrations:channels.centridesk.emails.is_default.activate")}}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                        <div style={{display: "flex", gap: 8, alignItems: "center", justifyContent: "center"}}>
                                                            {!busy && emailStatus === "failed" && <Button type="secondary"
                                                                text={t("integrations:channels.centridesk.emails.retry")}
                                                                onClick={() => this.startMailboxCreation(email.sender_email, true, null, email.id)}/>}
                                                            {busy && <Button type="secondary" text={t("integrations:channels.centridesk.emails.creation.check")}
                                                                onClick={() => this.startMailboxCreation(email.sender_email, false, email.operation)}/>}
                                                            <Tooltip title={t("integrations:channels.centridesk.emails.remove")} placement="top">
                                                                <IconButton disabled={!!busy} onClick={() => this.removeEmail(email.id)} style={{backgroundColor: "transparent"}} disableRipple disableFocusRipple aria-label={t("integrations:channels.centridesk.emails.remove")} size="small">
                                                                    {deleteSvg()}
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* HOURS CONTROL */}
                            <div className={"cen_integrations"}>
                                <div className={"header"}>
                                    <div className={"header_content"}>
                                        <div className={"header_title"}>
                                                <span
                                                    className={"title"}>{t("integrations:channels.centridesk.hours_control.title")}</span>
                                            <span
                                                className={"description"}>{t("integrations:channels.centridesk.hours_control.description")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={"integration"}>
                                    {
                                        limits.hours_control && hours && hours.active &&
                                        <React.Fragment>
                                            {/* ACTIVE */}
                                            <ElementsCustom
                                                t={t}
                                                type={"hours_control"}
                                                input_type={"switch"}
                                                element_type={"subject_active"}
                                                element={centridesk.info.hours_control.active}
                                                updateElement={this.updateElement}
                                            />
                                            <Divider/>
                                            {/* TICKET SUBJECT */}
                                            <ElementsCustom
                                                t={t}
                                                type={"hours_control"}
                                                input_type={"input"}
                                                element_type={"subject_hours_control"}
                                                element={centridesk.info.hours_control.subject}
                                                updateElement={this.updateElement}
                                            />
                                            <Divider/>
                                            {/* TAGS */}
                                            <ElementsCustom
                                                t={t}
                                                type={"hours_control"}
                                                input_type={"input_with_tags"}
                                                element_type={"tags_hours_control"}
                                                element={settings.tags_hours_control}
                                                elements={centridesk.info.hours_control.tags}
                                                updateElement={this.handleTags}
                                            />
                                            <Divider/>
                                            {/* STATUS */}
                                            <ElementsCustom
                                                t={t}
                                                type={"hours_control"}
                                                input_type={"select"}
                                                element_type={"status_hours_control"}
                                                element={centridesk.info.hours_control.status ? <span
                                                    className={`status ${centridesk.info.hours_control.status}`}>{t(`elements.custom.status.${centridesk.info.hours_control.status}`)}</span> : ""}
                                                elements={getStatusArray()}
                                                updateElement={this.onSelectStatus}
                                            />
                                        </React.Fragment>
                                    }
                                    {limits.hours_control && (!hours || !hours.active) && (
                                        <div className="info_message">
                                                <span>
                                                    {t("integrations:channels.centridesk.hours_control.no_active")} <Link
                                                    to={`/${match.params.project}/chatbot?tab=business_hours&to=business`}>{t("integrations:channels.centridesk.hours_control.title")}</Link>
                                                </span>
                                        </div>
                                    )}
                                    {!limits.hours_control && (
                                        <div className="info_message">
                                                <span>
                                                    {t("integrations:channels.centridesk.hours_control.no_limits")}
                                                </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* CENTRIPUSH */}
                            <div className={"cen_integrations"}>
                                <div className={"header"}>
                                    <div className={"header_content"}>
                                        <div className={"header_title"}>
                                                <span
                                                    className={"title"}>{t("integrations:channels.centridesk.centripush.title")}</span>
                                            <span
                                                className={"description"}>{t("integrations:channels.centridesk.centripush.description")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={"integration"}>
                                    {
                                        plan?.whatsapp_phones?.length > 0 && plan?.platform?.centripush ?
                                            <React.Fragment>
                                                {/* INDIVIDUAL */}
                                                <div className={"elements_custom"}>
                                                    <div className={"elements_custom__info"}>
                                                <span
                                                    style={{fontWeight: 500}}
                                                    className={"elements_custom__title"}>{t("integrations:channels.centridesk.centripush.individual.title")}</span>
                                                        <span
                                                            className={"elements_custom__description"}>{t("integrations:channels.centridesk.centripush.individual.description")}</span>
                                                    </div>
                                                </div>
                                                <Divider/>
                                                {/* ACTIVE */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"switch"}
                                                    element_type={"individual_active"}
                                                    element={centridesk.info.centripush.individual.active}
                                                    updateElement={this.updateElement}
                                                />
                                                <Divider/>
                                                {/* TICKET SUBJECT */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"input"}
                                                    element_type={"subject_individual"}
                                                    element={centridesk.info.centripush.individual.subject}
                                                    updateElement={this.updateElement}
                                                />
                                                <Divider/>
                                                {/* TAGS */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"input_with_tags"}
                                                    element_type={"tags_individual"}
                                                    element={settings.tags_individual}
                                                    elements={centridesk.info.centripush.individual.tags}
                                                    updateElement={this.handleTags}
                                                />
                                                <Divider/>
                                                {/* STATUS */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"select"}
                                                    element_type={"status_individual"}
                                                    element={centridesk.info.centripush.individual.status ? <span
                                                        className={`status ${centridesk.info.centripush.individual.status}`}>{t(`elements.custom.status.${centridesk.info.centripush.individual.status}`)}</span> : ""}
                                                    elements={getStatusArray()}
                                                    updateElement={this.onSelectStatus}
                                                />
                                                <Divider/>
                                                {/* CAMPAIGNS */}
                                                <div className={"elements_custom"}>
                                                    <div className={"elements_custom__info"}>
                                                        <span style={{fontWeight: 500, marginTop: 30}}
                                                              className={"elements_custom__title"}>{t("integrations:channels.centridesk.centripush.campaign.title")}</span>
                                                        <span
                                                            className={"elements_custom__description"}>{t("integrations:channels.centridesk.centripush.campaign.description")}</span>
                                                    </div>
                                                </div>
                                                <Divider/>
                                                {/* ACTIVE */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"switch"}
                                                    element_type={"campaign_active"}
                                                    element={centridesk.info.centripush.campaign.active}
                                                    updateElement={this.updateElement}
                                                />
                                                <Divider/>
                                                {/* TICKET SUBJECT */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"input"}
                                                    element_type={"subject_campaign"}
                                                    element={centridesk.info.centripush.campaign.subject}
                                                    updateElement={this.updateElement}
                                                />
                                                <Divider/>
                                                {/* TAGS */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"input_with_tags"}
                                                    element_type={"tags_campaign"}
                                                    element={settings.tags_campaign}
                                                    elements={centridesk.info.centripush.campaign.tags}
                                                    updateElement={this.handleTags}
                                                />
                                                <Divider/>
                                                {/* STATUS */}
                                                <ElementsCustom
                                                    t={t}
                                                    type={"centripush"}
                                                    input_type={"select"}
                                                    element_type={"status_campaign"}
                                                    element={centridesk.info.centripush.campaign.status ? <span
                                                        className={`status ${centridesk.info.centripush.campaign.status}`}>{t(`elements.custom.status.${centridesk.info.centripush.campaign.status}`)}</span> : ""}
                                                    elements={getStatusArray()}
                                                    updateElement={this.onSelectStatus}
                                                />
                                            </React.Fragment> :
                                            <div className="content">
                                                <div className="info_message">
                                                <span>
                                                    {t("integrations:channels.centridesk.centripush.no_active")}
                                                </span>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                            {/* DELETE */}
                            <div className={"cen_integrations delete"}>
                                <div className={"integration"}>
                                    <div className={"integration_info"}>
                            <span
                                className={"integration_info_title"}>{t("integrations:channels.centridesk.delete.title")}</span>
                                        <span
                                            className={"integration_info_description"}>{t("integrations:channels.centridesk.delete.description")}</span>
                                    </div>
                                    <Button type={"normal_delete"}
                                            text={t("integrations:channels.centridesk.delete.action_button")}
                                            onClick={() => this.setState({open: true})}/>
                                </div>
                            </div>
                            {/* DELETE MODAL */}
                            <DialogAction t={t} actualLayout={actualLayout.layout} handleAction={this.handleDelete}
                                          handleClickOpen={() => this.setState({open: false})} common open={open} item={{name: ""}}/>
                        </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const edit = connect(
    mapStateToProps
)(Edit);

export default withTranslation(["commons", "common"])(withRouter(edit));
